// @ts-nocheck
import '@material/web/menu/menu.js';
import '@material/web/menu/menu-item.js';
import { Typography, IconText } from '@taleemabad/dsm/components';
import styled from '@emotion/styled';
import { useEffect } from 'react';

interface menuProps {
  menuItems: menuItems[];
  open: boolean;
  anchorCorner?: 'end-start' | 'end-end' | 'start-start' | 'start-end';
  menuCorner?: 'end-start' | 'end-end' | 'start-start' | 'start-end';
  defaultFocus?: 'none' | 'list-root' | 'first-item' | 'last-item';
  positioning?: 'absolute' | 'fixed' | 'document' | 'popover' | 'undefined';
  xOffset?: number;
  yOffset?: number;
  onSelectedItem?: (data: menuItems) => void;
  onClose?: () => void;
}

export interface menuItems {
  id: number;
  name: string;
  value?: string;
  visible?: boolean;
  icon?: string;
}

export const Menu: React.FC<menuProps> = ({
  menuItems,
  open = false,
  anchorCorner = 'start-start',
  menuCorner = 'start-start',
  defaultFocus = 'none',
  positioning = 'fixed',
  xOffset = 0,
  yOffset = 0,
  onSelectedItem,
  onClose,
}) => {
  const props = {};
  if (open) {
    props.open = open;
  }
  if (anchorCorner) {
    props['anchor-corner'] = anchorCorner;
  }
  if (menuCorner) {
    props['menu-corner'] = menuCorner;
  }
  if (defaultFocus) {
    props['default-focus'] = defaultFocus;
  }
  if (positioning) {
    props.positioning = positioning;
  }
  useEffect(() => {
    const closeMenu = (event: MouseEvent) => {
      if (open) {
        const menu = document.getElementById('menu-anchor');
        if (menu && !menu.contains(event.target)) {
          onClose?.();
        }
      }
    };
    document.addEventListener('click', closeMenu);
    return () => {
      document.removeEventListener('click', closeMenu);
    };
  }, [open, onClose]);

  return (
    <md-menu
      id="menu-anchor"
      anchor="menu-anchor"
      x-offset={xOffset}
      y-offset={yOffset}
      tabindex={0}
      {...props}
    >
      {menuItems?.map(
        (item) =>
          item.visible !== false && (
            <md-menu-item
              type="menuitem"
              key={item.id}
              style={listItemToken}
              onClick={() => {
                onSelectedItem?.(item);
              }}
            >
              {item.icon ? (
                <IconText
                  icon={item.icon}
                  text={item.name}
                  textVariant="textBodyLarge"
                />
              ) : (
                <StyledTypography
                  data-cy={`${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                  slot="headline"
                  variant="textBodyLarge"
                >
                  {item.name}
                </StyledTypography>
              )}
            </md-menu-item>
          ),
      )}
    </md-menu>
  );
};

const StyledTypography = styled(Typography)`
  text-align: left;
`;
const listItemToken = {
  textAlign: 'left',
};
